import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
var propTypes = {
  /**
  * Visual style of the StandardTile.
  * Available options: "standard", "product", "gallery", "circular"
  */
  skin: PropTypes.oneOf(['standard', 'product', 'gallery', 'circular']),

  /**
  * Specifies whether the tile is vertically or horizontally oriented
  * Available options: "vertical", "horizontal"
  */
  layout: PropTypes.oneOf(['vertical', 'horizontal']),

  /**
  * The tile background
  * Available options: "standard", "translucent"
  */
  background: PropTypes.oneOf(['standard', 'translucent']),

  /**
  * Width setting for the image on the tile
  * Available options: "standard", "full-bleed"
  */
  imageWidth: PropTypes.oneOf(['standard', 'full-bleed']),

  /**
  * Specifies if the image shadow should have a shadow
  */
  imageShadow: PropTypes.bool
};
var StandardTile = createComponent({
  displayName: 'StandardTile',
  root: 'div',
  propTypes: propTypes,
  requiredStyleKeys: SWAN_STYLE_KEY_MAP.standardTile,
  propConfig: {
    classNames: function classNames(_ref) {
      var skin = _ref.skin,
          layout = _ref.layout,
          background = _ref.background,
          imageWidth = _ref.imageWidth,
          imageShadow = _ref.imageShadow;
      var classesSet = new Set(['swan-standard-tile']);
      if (skin !== 'standard') classesSet.add("swan-standard-tile-skin-".concat(skin));
      if (layout === 'horizontal') classesSet.add('swan-standard-tile-horizontal');
      if (background === 'translucent' && skin === 'gallery') classesSet.add('swan-standard-tile-background-translucent');
      if (imageWidth === 'full-bleed' && skin === 'product') classesSet.add('swan-standard-tile-full-bleed');
      if (imageShadow === false && skin === 'gallery') classesSet.add('swan-standard-tile-hide-image-shadow');
      return classesSet;
    }
  }
});
StandardTile.defaultProps = {
  skin: 'standard',
  layout: 'vertical',
  imageWidth: 'standard'
};
export { StandardTile };